import { render, staticRenderFns } from "./ClientPhones.vue?vue&type=template&id=32ebd70c&scoped=true&"
import script from "./ClientPhones.vue?vue&type=script&lang=js&"
export * from "./ClientPhones.vue?vue&type=script&lang=js&"
import style0 from "./ClientPhones.vue?vue&type=style&index=0&id=32ebd70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebd70c",
  null
  
)

export default component.exports